import React, { useState } from 'react';
import './SeedProcessingQuality.css';
import seedProcessingLogo from '../images/seedprocessing-logo.png';
import processingimg1 from '../images/processing-image1.jpeg';
import seedProductionImage from '../images/processing-image2.jpeg';

const slides = [
  {
    src: processingimg1,
    alt: 'Seed processing facility view 1',
  },
  {
    src: seedProcessingLogo,
    alt: 'Seed processing and quality logo',
  },
  {
    src: seedProductionImage,
    alt: 'Seed production facility view',
  },
];

export default function SeedProcessingQuality() {
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <div className="spq-page service-page">
      {/* Hero Banner */}
      <section className="service-hero-banner">
        <img
          src={seedProcessingLogo}
          alt="Seed Processing and Quality"
          className="service-hero-banner__image"
        />
        <div className="service-hero-banner__overlay">
          <h1>Seed Processing &amp; Quality</h1>
        </div>
      </section>
      {/* Image Slider
      <section className="spq-slider-section">
        <img src={processingimg1} alt="Seed Processing" className="spq-slider-section__image" />
      </section> */}
      {/* Main Content */}
      <main className="spq-main">
        <div className="spq-top">
          <div className="spq-slider">
            <div className="spq-slider__img">
              <img
                src={slides[activeSlide].src}
                alt={slides[activeSlide].alt}
                className="spq-slider__image"
              />
            </div>
            <div className="spq-slider__dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  className={`spq-dot${i === activeSlide ? ' spq-dot--active' : ''}`}
                  onClick={() => setActiveSlide(i)}
                  aria-label={`Slide ${i + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="spq-top__text">
            {/* <h2>Seed Processing &amp; Quality</h2> */}
            <p>
              The quality is always our unchanging principle. Dynasty Agri Seeds being a local seed company, is
              highly committed to give a real value and always work for 'Quality' to meet the challenging needs
              at all stages of supply chain management. Seeds are tested as per the International Seed Testing
              Association (ISTA) procedures and standards.
            </p>
            <p>
              The seeds received from the production centers are subject to seed processing and quality
              assessment. Seed processing involves all the steps which makes the harvested seed ready for
              marketing with its physical and genetic purity tested at different stages in production system.
            </p>
          </div>
        </div>

        <div className="spq-sections">
          <div className="spq-section">
            <h3 className="spq-section__title">Seed Drying</h3>
            <div className="spq-section__underline" />
            <p className="spq-section__text">
              Seeds are dried to a safe moisture level by sun drying and by using dryers in order to maintain the
              viability and vigor for a very long time.
            </p>
          </div>

          <div className="spq-section">
            <h3 className="spq-section__title">Seed Cleaning and Size Grading</h3>
            <div className="spq-section__underline" />
            <p className="spq-section__text">
              The Company is have a separate processing unit equipped with different types of machines. The
              graders are used to separate the seeds according to the size, which includes laboratory model
              grader. The gravity separators are used to separate the seeds based on the density. Some kind of
              seeds like flower seeds are separated with the help of cylindrical separator to maintain the uniform
              shape and size. The seed blower is used to separate heavy and light fractions for small sized and
              other exotic flower seeds. The seed brushing machine is used to remove the hairiness of the seeds.
              By this way the undesirable fractions namely inert matter, weed seeds, other crop seeds, light and
              chaffy seeds are removed from the desirable seed lots.
            </p>
          </div>

          <div className="spq-section">
            <h3 className="spq-section__title">Seed Testing</h3>
            <div className="spq-section__underline" />
            <p className="spq-section__text">
              Dynasty Agri Seeds laboratory forms the hub of quality control activities. Seed is tested for moisture
              content, physical purity, germination, genetic purity and seed health. The germination tests are
              conducted based on International Seed Testing Association (ISTA) rules.
            </p>
          </div>

          <div className="spq-section">
            <h3 className="spq-section__title">Genetic Purity Test</h3>
            <div className="spq-section__underline" />
            <p className="spq-section__text">
              Genetic purity is trueness to the type. The company adapts a biochemical technique called
              Iso-electric focusing for testing genetic purity/MAS wherever required. Highly precise results are
              obtained regularly within a span of three hours and are cross compared with regular Grow Out Test
              (GOT) results. The genetic purity is directly related to the uniformity of the crop. In order to conduct
              GOT, it is having a separate farm where all the seed lots are tested before released to the market.
            </p>
          </div>

          <div className="spq-section">
            <h3 className="spq-section__title">Seed Health Test</h3>
            <div className="spq-section__underline" />
            <p className="spq-section__text">
              Healthy seed is one which does not contain any seed borne disease causing organism. Seed is tested
              for the presence or absence of seed borne pathogens by direct examination with the help stereo
              binocular microscope and indirectly by ELISA (Enzyme Linked Immuno Sorbant Assay) and PCR
              (Polymarase Chain Reaction). To know the disease incidents within a short period of time these tests
              will be regularly conducted before seeds are packed and shipped.
            </p>
          </div>

          <div className="spq-section">
            <h3 className="spq-section__title">Seed Storage</h3>
            <div className="spq-section__underline" />
            <p className="spq-section__text">
              Dynasty Agri Seeds has state-of-the-art storage facility where seeds are stored in both controlled and
              an ordinary warehouse as per the technical specifications. In case of conditioned storage, temperature
              and relative humidity are maintained as per the crop requirement and seeds are packed under
              dehumidifying condition in air tight containers.
            </p>
          </div>

          <div className="spq-section">
            <h3 className="spq-section__title">Seed Treatment and Coating</h3>
            <div className="spq-section__underline" />
            <p className="spq-section__text">
              The seeds are coated with organic polymers and appropriate chemicals in the seed coating machine.
              The fungicides and insecticides are mixed with polymers and coated directly on the seeds to avoid
              post emergence diseases. The coated seed are free flowing in nature and suitable for mechanical
              sowing. The treated seeds are dust free and environmental friendly.
            </p>
          </div>
        </div>
      </main>

    </div>
  );
}